<ep-sub-panel [form]="form" panelType="transparent" collapseTitleArea="true">
  <h4><b>Document Information</b></h4>

  <div>
    <div *ngFor="let doc of documents$ | async; let row = index">
      <ep-document-info-edit-panel [docID]="doc.Doc_ID"></ep-document-info-edit-panel>
    </div>
  </div>
  <hr />
  <h4>
    <b>New Filing Reference Info</b>
  </h4>
  <form [formGroup]="form">
    <ep-field
      columnSpan="2"
      label="Contract"
      format="search-contract"
      controlPath="Filing.Contract.Contract_ID"
      descControlPath="Filing.Contract.Contract_Num"
      [options]="{ autoSearch: false, allowClear: true }"
      [criteria]="{
        Contract_Set_Status: 'Inforce;SubOpen;PendingEff;SubReject;Expired;Cancelled',
        Range: 'All',
        Contract_Num_Mode: 'BeginsWith',
        json: 'CT2'
      }"
      (dataSelected)="contractSearchResult($event)"
      (dataCleared)="contractSearchCleared()"
    >
    </ep-field>
    <ep-field
      columnSpan="2"
      label="Claim"
      format="search-claim"
      controlPath="Filing.Claim.Claim_ID"
      descControlPath="Filing.Claim.Book_Claim_Num"
      [options]="{ autoSearch: false, allowClear: true }"
      [criteria]="{
        Contract_Set_Status: 'Inforce;SubOpen;PendingEff;SubReject;Expired;Cancelled',
        Range: 'All'
      }"
      (dataSelected)="claimSearchResult($event)"
      (dataCleared)="claimSearchCleared()"
    >
    </ep-field>

    <hr />
    <h4><b>Add Filing To</b></h4>
    <ep-field
      columnSpan="2"
      label="Entity"
      format="search-entity"
      controlPath="Filing.Entity.Entity_ID"
      descControlPath="Filing.Entity.Entity_Name"
      [options]="{ autoSearch: false, allowClear: true }"
      [criteria]="{}"
      (dataSelected)="entitySearchResult($event)"
    >
    </ep-field>
    <ep-field format="container" columnSpan="2">
      <aurora-button type="button" (click)="clearNewFilings()" variant="tertiary">Clear New Filings</aurora-button>
    </ep-field>
  </form>
</ep-sub-panel>
